import React from 'react'
import PropTypes from 'prop-types'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'

import './FooterGroup.scss';

const FooterGroup = (props) =>
    <div className='footer-group'>
        <div className='title'>{props.title}</div>
        <ul>
            {props.children}
        </ul>
    </div>

export default FooterGroup;


// WEBPACK FOOTER //
// ./src/components/footer/FooterGroup.jsx